<template lang="pug">
    div
      validation-provider(rules="required", v-slot="{ errors }", name="Peça Técnica/Geometria")
        mapa(
          @onRemoveGeometria="onRemoveGeometria",
          @atualizarGeorreferenciamento="atualizarPecaTecnica"
          :geom="geom",
          v-model="geom",
          name="Geometria",
          :errors="errors"
        )
        span.help.erro {{ errors[0] }}
      .mt-1
        informacoes-area-arrecadacao(
          :area="area"
          :perimetro="perimetro"
          :municipios="municipios"
        )
      div(v-if="documentosAutenticavel")
        app-visualizar-documentos(
          :dadosCadastros="getDocumentosAutenticaveis()"
        )
      div(v-if="documentosCadastro")
        app-visualizar-documentos(
          :dadosCadastros="getDocumentos()"
          :showValidacaoDocumentos="showValidacaoDocumentos"
          @setValidacaoDocumentos="setValidacaoDocumentos",
          :showDocumentosValidos="false"
        )
  </template>

<script>
import { mapActions } from 'vuex'
import InformacoesAreaArrecadacao from '@/screens/arrecadacao/components/InformacoesAreaArrecadacao'
import Mapa from '@/screens/arrecadacao/gat/components/Mapa'
import AppVisualizarDocumentos from '@/components/AppVisualizarDocumentos.vue'
import Utils from '@/utils/utils'
import FileHelper from '@/utils/fileHelper'
import AppActionButton from '@/components/AppActionButton'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    Mapa,
    InformacoesAreaArrecadacao,
    AppVisualizarDocumentos,
    AppActionButton,
    FileHelper
  },

  props: {
    cadastroColetivo: {
      required: true,
      type: Object
    },
    isResumo: {
      required: false,
      default: false,
      type: Boolean
    }
  },

  computed: {
    pecaTecnica () {
      return this.cadastroColetivo.pecaTecnica
    },

    geom () {
      return this.pecaTecnica.geom
    },

    area () {
      const json = JSON.parse(this.pecaTecnica.dadoPecaTecnica?.jsonPlanilha)
      if (json) {
        return this.format(json?.identificacaoPlanilha?.areaTotal, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
      }
      return this.format(this.pecaTecnica?.area, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
    },

    perimetro () {
      const json = JSON.parse(this.pecaTecnica?.dadoPecaTecnica?.jsonPlanilha)
      if (json) {
        return this.format(json?.identificacaoPlanilha?.perimetroTotal, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
      }
      return this.format(this.pecaTecnica?.perimetro)
    },

    municipios () {
      return this.pecaTecnica.municipios
    },

    dataEntrada () {
      return this.cadastroColetivo.dataCriacao || '-'
    },
    documentosAutenticavel () {
      return this.pecaTecnica?.dadoPecaTecnica?.documentosAutenticavel
    },
    documentosCadastro () {
      return this.pecaTecnica?.dadoPecaTecnica?.documentos
    }
  },

  data () {
    return {
      showValidacaoDocumentos: false
    }
  },

  async created () {
    const user = await this.getUsuario()
    this.showValidacaoDocumentos = regrasAnalise.showValidacaoDocumentos.perfis.includes(user.perfilSelecionado.codigo) && !this.isResumo
  },

  methods: {
    format: Utils.format,

    ...mapActions({
      getUsuario: 'auth/getUsuario',
      downloadDocumentos: 'documentoArrecadacao/download'
    }),

    setValidacaoDocumentosAutenticaveis (dadosCadastro) {
      let i = 0
      this.getDocumentosAutenticaveis().map((dados, index) => {
        if (dados.tipo === dadosCadastro.tipo) {
          i = index
        }
      })
      this.getDocumentosAutenticaveis()[i] = dadosCadastro
    },

    setValidacaoDocumentos (dadosCadastro) {
      let i = 0
      this.getDocumentos().map((dados, index) => {
        if (dados.tipo === dadosCadastro.tipo) {
          i = index
        }
      })
      this.getDocumentos()[i] = dadosCadastro
      this.$emit('validacaoDocumentos', this.getDocumentos()[i].data)
    },

    onRemoveGeometria () {
      this.$emit('onRemoveGeometria')
    },

    atualizarPecaTecnica (pecaTecnica) {
      this.$emit('atualizarPecaTecnica', pecaTecnica)
    },

    changeData (data) {
      this.pecaTecnica[data.campo] = data.valor
      this.atualizarPecaTecnica(this.pecaTecnica)
    },
    getDocumentosAutenticaveis () {
      const headers = [{ propriedade: 'tipoDocumentoAutenticavel.descricao', titulo: 'Tipo de documento' }, { propriedade: 'nomeArquivo', titulo: 'Nome do arquivo' }, { propriedade: 'visualizar', titulo: '' }]
      const dados = {
        label: 'Documentos Autenticáveis',
        tipo: 'tabelaComCheck',
        headers: headers,
        data: this.documentosAutenticavel
      }
      return [dados]
    },
    getDocumentos () {
      const headers = [{ propriedade: 'tipoDocumento.nome', titulo: 'Tipo de documento' }, { propriedade: 'nomeOriginal', titulo: 'Nome do arquivo' }, { propriedade: 'visualizar', titulo: '' }]
      const dados = {
        label: 'Documentos',
        tipo: 'tabelaComCheck',
        headers: headers,
        data: this.documentosCadastro
      }
      return [dados]
    }
  }
}
</script>

  <style lang="scss" scoped>
  .info-container {
    padding-top: 10px;
  }

  .label {
    font-weight: bold;
    margin-right: 10px;
  }

  p {
    font-size: 15px;
  }

  ul {
    list-style-type: none;
    margin-top: 0px;
  }
  </style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gat/components/PecaTecnica.vue